export const formatNumber = (number) => {
  if (number === '' || number === 0) return '';  
  return new Intl.NumberFormat('en-GB', {style: 'decimal', maximumFractionDigits: 2 }).format(number);
};

export const formatDecimal = (number) => {  
    if (number === '' || number === 0) return '';    
    return new Intl.NumberFormat('en-GB', {style: 'decimal', maximumFractionDigits: 2, minimumFractionDigits: 2}).format(number);  
}